import { ConfigStep } from './config-step/config-step';
import { MappingStep } from './mapping-step/mapping-step';
import { ImportProcessingStep } from './import-processing-step/import-processing-step';

export const orderImportSteps = [ConfigStep, MappingStep, ImportProcessingStep];
